export const OFFERING_TYPES = {
  PRODUCT: "PRODUCT",
  SERVICE: "SERVICE",
  SOLUTION: "SOLUTION",
};


export const OFFERING_TYPE_LABELS = {
  PRODUCT: "Product",
  SERVICE: "Service",
  SOLUTION: "Solution",
};


export const PRICING_TYPES = {
  FIXED: "FIXED",
  CUSTOM: "CUSTOM",
};


export const PRICING_TYPE_LABELS = {
  FIXED: "Fixed",
  CUSTOM: "Custom",
};